<template>
  <div v-if="ifTestSend === false && (ifTestOpened === false || dayRemaining == null)" class="file-section">
    <div class="file-section-content">
      <div>
        <div class="file-circle"/>
      </div>
      <div class="file-section-content-label">Tests</div>
      <div>
        <div class="file-icon"><img src="@/assets/img/file/padlock-close.png" alt=""></div>
      </div>
    </div>
  </div>

  <div v-else-if="ifTestSend === true || (ifTestFinished && ifTestOpened)" class="file-section file-section--active">
    <div class="file-section-content">
      <div>
        <div class="file-circle file-circle--active"/>
      </div>
      <div class="file-section-content-label">Tests</div>
      <div v-if="ifTestFinished" class="file-icon file-icon--active" @click="toggleInfo">
        <img src="@/assets/img/file/eye.png" alt="">
      </div>
    </div>
    <div v-if="showInfo" class="file-section-info">
      <div class="file-section-info-separator"/>
      <div v-if="MaN === -1">
        Votre centre de rattachement est en cours de traitement de vos résultats.<br>
        Revenez d'ici quelques jours, pour savoir si votre centre préconise des heures de mises à niveau pendant votre formation.
      </div>
      <div v-else-if="MaN > 0">
        Suite aux résultats de vos tests en ligne, nous préconisons {{ MaN }} heures de mises à niveau à effectuer pendant votre formation
        (
        <span v-if="NB_H_RAN_MA_OF > 0">{{ NB_H_RAN_MA_OF }} heures en calculs professionnels</span>
        <span v-if="NB_H_RAN_MA_OF > 0 && (NB_H_RAN_FR_OF > 0 || NB_H_RAN_AR_OF > 0)">, </span>
        <span v-if="NB_H_RAN_FR_OF > 0 || NB_H_RAN_AR_OF > 0">20 heures en français</span>
        ).
      </div>
      <div v-else-if="MaN === 0">
        Suite aux résultats de vos tests en ligne, nous vous informons que vous n'avez pas besoin de mises à niveau pendant votre formation.
      </div>
    </div>
  </div>

  <div v-else-if="dayRemaining < 0" class="file-section file-section--critical">
    <div class="file-section-content">
      <div>
        <div class="file-circle file-circle--critical"/>
      </div>
      <div class="file-section-content-label">Tests</div>
      <div>
        <div class="file-icon file-icon--critical"><img src="@/assets/img/file/pen.png" alt=""></div>
      </div>
    </div>
    <div class="file-section-info">
      <div class="file-section-info-separator"/>
      Le délai d'accès aux tests a été dépassé. Vous ne pouvez plus y accédez.<br><br>
      Veuillez contacter le centre de formation affecté à votre candidature pour redemander un accès aux tests [via Messages].
    </div>
  </div>

  <div v-else-if="dayRemaining <= 2" class="file-section file-section--warning file-section--pointer" @click="toTests">
    <div class="file-section-content">
      <div>
        <div class="file-circle file-circle--warning"/>
      </div>
      <div class="file-section-content-label">Tests</div>
      <div v-if="dayRemaining > 0" class="file-section-content-remaining-date">{{ dayRemaining }} jour(s) restant(s)</div>
      <div v-else class="file-section-content-remaining-date">Dernier jour</div>
      <div>
        <div class="file-icon file-icon--warning"><img src="@/assets/img/file/pen.png" alt=""></div>
      </div>
    </div>
  </div>

  <div v-else-if="dayRemaining > 2" class="file-section file-section--active file-section--pointer" @click="toTests">
    <div class="file-section-content">
      <div>
        <div class="file-circle file-circle--active"/>
      </div>
      <div class="file-section-content-label">Tests</div>
      <div class="file-section-content-remaining-date">{{ dayRemaining }} jour(s) restant(s)</div>
      <div>
        <div v-if="ifTestEnCours === true" class="file-icon file-icon--active"><img src="@/assets/img/file/pen.png" alt=""></div>
        <div v-else class="file-icon file-icon--active"><img src="@/assets/img/file/padlock-open.png" alt=""></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FileTest",
  props: {
    ifTestOpened: Boolean,
    ifTestFinished: Boolean,
    dayRemaining: Number,
    ifTestEnCours: Boolean,
    ifTestSend: Boolean,
    NB_H_RAN_MA_OF: Number,
    NB_H_RAN_FR_OF: Number,
    NB_H_RAN_AR_OF: Number
  },
  data() {
    return {
      showInfo: false
    };
  },
  computed: {
    MaN() {
      if (null === this.NB_H_RAN_MA_OF || null === this.NB_H_RAN_FR_OF || null === this.NB_H_RAN_AR_OF) {
        return -1;
      }
      return (this.NB_H_RAN_MA_OF || 0) + (this.NB_H_RAN_FR_OF || 0) + (this.NB_H_RAN_AR_OF || 0);
    }
  },
  methods: {
    toTests: function () {
      this.$router.push({name: 'mes-tests'});
    },
    toggleInfo: function () {
      this.showInfo = !this.showInfo;
    }
  },
  mounted() {
  }
};
</script>
